import { Action } from '../../actions/index';
import storageSession from 'redux-persist/lib/storage/session';
import { persistReducer } from 'redux-persist';

export const GET_CONTENTFUL_PRODUCTS = 'GET_CONTENTFUL_PRODUCTS'
/**
 * This file is responsible for managing data for products given by contentful
 * 
 * We store it here because it is used in multiple places (header, navigation and reference), 
 * 
 * */


export interface IContentfulProductsState {
    error: boolean,
    loading: boolean,
    data?: {
        productOverviewPageCollection: {
            items: [{
                eyebrow: string,
                productName: string,
                publishReady: boolean
                introductionText: string,
                accessText: string,
                docUrl?: string,
                exampleUrl?: string,
                associatedIcon: {
                    url: string,
                    title: string
                },
                includedApis: {
                    apis: [{
                        name: string,
                        version: string,
                        href: string
                    }]
                },
                sys: {
                    id: string
                }
            }]
        }
    }
}
const initialContentfulProducts: IContentfulProductsState = {
    error: false,
    loading: false,
    data: null,
}
export function getContentfulProductsReducerd(state = initialContentfulProducts, action: Action<IContentfulProductsState['data']>) {
    //Refactor idea: Make this type of switch generic
    switch (action.type) {
        case `${GET_CONTENTFUL_PRODUCTS}_PENDING`:
            return { ...state, loading: true, error: false }
        case `${GET_CONTENTFUL_PRODUCTS}_FULFILLED`:
            return { ...state, loading: false, error: false, data: action.payload }
        case `${GET_CONTENTFUL_PRODUCTS}_REJECTED`:
            return { ...state, loading: false, error: true }
        default: return state;
    }
}

const persistConfig = {
    key: 'contentfulProducts',
    storage: storageSession,    
}

const getContentfulProductsReducer = persistReducer(persistConfig, getContentfulProductsReducerd)
export default getContentfulProductsReducer;